const PRACTICE_QUESTIONS = [

    /* ============= DOMAIN 1: General Security Concepts (11) ============= */
    {
        id: 1, domain: "D1",
        q: "An organization wants to ensure that a former employee cannot deny sending a particular email after their termination. Which security principle is most directly addressed?",
        options: [
            "Confidentiality",
            "Integrity",
            "Non-repudiation",
            "Availability"
        ],
        correct: 2,
        explanation: "Non-repudiation provides assurance that a party cannot deny the validity of an action they performed. Digital signatures and detailed logging are the primary mechanisms. Confidentiality protects against disclosure, integrity protects against modification, and availability ensures access — none of which directly prevent denial of an action."
    },
    {
        id: 2, domain: "D1",
        q: "A security analyst is implementing a control that automatically locks an account after five failed login attempts. Which two control TYPES best describe this measure?",
        options: [
            "Preventive and Detective",
            "Preventive and Deterrent",
            "Compensating and Corrective",
            "Detective and Corrective"
        ],
        correct: 1,
        explanation: "Account lockout PREVENTS continued brute-force attempts (preventive) and DISCOURAGES attackers from continuing (deterrent). It does not detect after the fact, nor does it correct an existing condition. Note that a single control can satisfy multiple types."
    },
    {
        id: 3, domain: "D1",
        q: "Which component in a Zero Trust architecture is responsible for granting or denying access requests by evaluating policies?",
        options: [
            "Policy Enforcement Point (PEP)",
            "Policy Engine (PE)",
            "Policy Administrator (PA)",
            "Identity Provider (IdP)"
        ],
        correct: 1,
        explanation: "The Policy Engine (PE) is the brain that makes the access decision based on policy and context. The Policy Administrator (PA) communicates that decision to the Policy Enforcement Point (PEP), which actually enforces it on the data plane. The IdP supplies identity but does not make policy decisions."
    },
    {
        id: 4, domain: "D1",
        q: "An organization stores customer passwords using SHA-256 hashing. A penetration tester recommends switching to bcrypt with a high work factor. What is the primary reason for this recommendation?",
        options: [
            "bcrypt produces longer hash outputs that are harder to collide",
            "bcrypt uses asymmetric encryption to protect the hash",
            "bcrypt is intentionally slow, making brute force computationally expensive",
            "bcrypt automatically salts passwords with a global secret"
        ],
        correct: 2,
        explanation: "bcrypt is a key-stretching function designed to be deliberately slow (configurable via work factor). This makes large-scale brute force or rainbow table attacks computationally expensive. SHA-256 is fast — billions of guesses per second on modern GPUs — making it unsuitable for password storage on its own."
    },
    {
        id: 5, domain: "D1",
        q: "An auditor finds that a company's CA has been issuing certificates but has not been publishing revocation status quickly enough for relying parties. Which protocol would BEST reduce the time between revocation and detection?",
        options: [
            "CRL distributed once per week",
            "OCSP with stapling",
            "Certificate pinning",
            "Forward secrecy"
        ],
        correct: 1,
        explanation: "OCSP (Online Certificate Status Protocol) provides near-real-time revocation checking. With OCSP stapling, the server includes a recent OCSP response in its TLS handshake, eliminating client-side latency. CRLs are published periodically and lag behind. Pinning addresses CA compromise, not revocation timing."
    },
    {
        id: 6, domain: "D1",
        q: "A junior admin places a fake credentials file named 'admin_credentials.txt' on a public file share. Any access to this file triggers an alert. What technique is being used?",
        options: [
            "Honeynet",
            "Honeypot",
            "Honeyfile / Honeytoken",
            "Sinkhole"
        ],
        correct: 2,
        explanation: "A honeyfile (or honeytoken) is fake data placed in legitimate systems specifically to detect unauthorized access. Legitimate users have no reason to open it, so any access strongly indicates an intrusion. A honeypot is an entire decoy system; a honeynet is a network of them; a sinkhole reroutes malicious DNS traffic."
    },
    {
        id: 7, domain: "D1",
        q: "Which scenario is the BEST application of separation of duties?",
        options: [
            "Requiring users to use multi-factor authentication",
            "Splitting the ability to create vendor records and approve vendor payments between two different roles",
            "Encrypting data both at rest and in transit",
            "Rotating administrative credentials every 30 days"
        ],
        correct: 1,
        explanation: "Separation of duties divides a sensitive process across multiple individuals so no single person can complete it alone — preventing fraud. Splitting vendor creation from payment approval is a classic SoD example. MFA, encryption, and credential rotation are valuable but address different principles."
    },
    {
        id: 8, domain: "D1",
        q: "A financial institution wants to share regulated customer data with a third-party analytics vendor without exposing actual account numbers. The mapping must be reversible only via a secured vault. Which technique satisfies these requirements?",
        options: [
            "Hashing",
            "Tokenization",
            "Steganography",
            "Data masking"
        ],
        correct: 1,
        explanation: "Tokenization replaces sensitive data with non-sensitive tokens that can be mapped back to the original via a secured vault — by design, reversible only with vault access. Hashing is irreversible. Masking is typically irreversible/static. Steganography hides data inside other data, not a fit for this use case."
    },
    {
        id: 9, domain: "D1",
        q: "A 256-bit elliptic curve key is considered to provide approximately equivalent security to which RSA key size?",
        options: [
            "1024-bit RSA",
            "2048-bit RSA",
            "3072-bit RSA",
            "15360-bit RSA"
        ],
        correct: 2,
        explanation: "ECC achieves equivalent security at much smaller key sizes than RSA. NIST equivalence: ECC-256 ≈ RSA-3072 (≈128-bit symmetric strength), ECC-384 ≈ RSA-7680, ECC-521 ≈ RSA-15360. This is why ECC is favored for resource-constrained environments."
    },
    {
        id: 10, domain: "D1",
        q: "A change management board reviews a proposed firewall rule modification. Which item is MOST important to include in the change request?",
        options: [
            "Marketing impact statement",
            "Backout (rollback) plan",
            "Vendor contract status",
            "Employee training schedule"
        ],
        correct: 1,
        explanation: "A backout plan is essential for any change — it defines how to revert if the change causes problems. Without it, a failed change could result in extended outages. The other items may be relevant in other contexts but are not the most critical CAB review item for a firewall change."
    },
    {
        id: 11, domain: "D1",
        q: "A company wants to ensure that even if its TLS private key is compromised in the future, past recorded sessions cannot be decrypted. Which property must the chosen cipher suite provide?",
        options: [
            "AEAD (authenticated encryption)",
            "Forward secrecy",
            "Certificate pinning",
            "Key escrow"
        ],
        correct: 1,
        explanation: "Forward secrecy (also called perfect forward secrecy) ensures that ephemeral session keys cannot be derived from the long-term private key. Achieved via DHE or ECDHE key exchange. AEAD provides integrity, pinning prevents fraudulent CAs, and escrow is the OPPOSITE of forward secrecy."
    },

    /* ============= DOMAIN 2: Threats & Mitigations (20) ============= */
    {
        id: 12, domain: "D2",
        q: "An attacker registers the domain 'paypa1.com' (with a numeral 1) hoping users will mistype the legitimate domain. What attack is this?",
        options: [
            "DNS poisoning",
            "Pharming",
            "Typosquatting",
            "Watering hole attack"
        ],
        correct: 2,
        explanation: "Typosquatting (also called URL hijacking) registers domains that look similar to legitimate ones to capture mistyped traffic. DNS poisoning corrupts resolver caches, pharming redirects via compromised DNS or hosts file, and watering hole attacks compromise sites the target group already visits."
    },
    {
        id: 13, domain: "D2",
        q: "Multiple employees receive an email appearing to come from the CEO instructing them to wire funds urgently to a new vendor. There are no malicious attachments or links. What attack BEST describes this?",
        options: [
            "Whaling",
            "Spear phishing",
            "Business Email Compromise (BEC)",
            "Vishing"
        ],
        correct: 2,
        explanation: "BEC specifically involves impersonating an executive or trusted partner to manipulate financial actions, often without any malware — just social engineering. Whaling targets the executive themselves; spear phishing is targeted but broader; vishing uses voice calls."
    },
    {
        id: 14, domain: "D2",
        q: "A web application allows users to enter their name into a form field. The application later displays this name to other users without sanitization. An attacker enters: <script>alert('XSS')</script>. Other users see the popup when viewing the attacker's profile. Which type of XSS is this?",
        options: [
            "Reflected XSS",
            "Stored (Persistent) XSS",
            "DOM-based XSS",
            "Self-XSS"
        ],
        correct: 1,
        explanation: "Stored (persistent) XSS occurs when malicious script is saved on the server (in a database, profile, or comment) and executes when other users view the affected content. Reflected XSS is delivered via a single request/response. DOM-based XSS executes entirely in the browser via JavaScript modification."
    },
    {
        id: 15, domain: "D2",
        q: "A developer notices a function that checks file permissions, then opens the file a few milliseconds later. An attacker exploits the gap to swap the file with a symlink. What vulnerability category is this?",
        options: [
            "Buffer overflow",
            "TOCTOU (race condition)",
            "Integer overflow",
            "Use-after-free"
        ],
        correct: 1,
        explanation: "Time-Of-Check to Time-Of-Use (TOCTOU) is a race condition where the state of a resource changes between when it's verified and when it's used. The fix is to use atomic operations (e.g., open the file with privileges and check on the opened handle, not the path)."
    },
    {
        id: 16, domain: "D2",
        q: "Which BEST mitigates SQL injection in a web application?",
        options: [
            "Encoding all user input as Base64 before processing",
            "Using parameterized queries (prepared statements)",
            "Hashing input with SHA-256 before sending it to the database",
            "Disabling JavaScript on the client side"
        ],
        correct: 1,
        explanation: "Parameterized queries (prepared statements) cause the database to treat user input strictly as data, never as executable SQL — eliminating injection entirely. Encoding does not prevent injection. Hashing breaks legitimate queries. Disabling JavaScript is unrelated; SQLi is a server-side issue."
    },
    {
        id: 17, domain: "D2",
        q: "An organization's monitoring detects high-volume DNS queries from an internal host to a domain known for DGA (Domain Generation Algorithm) activity. What threat is MOST likely?",
        options: [
            "Phishing campaign",
            "Command-and-control (C2) callback from malware",
            "Insider threat exfiltration",
            "Distributed denial of service"
        ],
        correct: 1,
        explanation: "DGAs generate large numbers of pseudo-random domains so malware can locate active C2 servers without hardcoded addresses. High DNS query volume to DGA-style domains is a hallmark of C2 callback activity. Mitigation: DNS filtering, sinkholing, and EDR."
    },
    {
        id: 18, domain: "D2",
        q: "A user reports their files have new extensions (.locked) and a ransom note appears on the desktop. The IT team's first containment action should be:",
        options: [
            "Pay the ransom to recover the files immediately",
            "Run a full antivirus scan with the host online",
            "Disconnect the host from the network and isolate it",
            "Reformat the host immediately to remove evidence of the attack"
        ],
        correct: 2,
        explanation: "Containment first — disconnecting the host prevents lateral movement and additional encryption while preserving forensic evidence. Paying ransoms encourages further attacks and provides no guarantee. Running AV online could destroy artifacts. Reformatting destroys evidence and skips investigation."
    },
    {
        id: 19, domain: "D2",
        q: "A vendor releases a security patch for a known vulnerability. Before the patch is widely deployed, an attacker successfully exploits it in the wild. What term BEST describes the exploit?",
        options: [
            "Zero-day exploit",
            "N-day exploit",
            "Wildcard exploit",
            "Side-channel exploit"
        ],
        correct: 1,
        explanation: "An N-day exploit targets a vulnerability that has been disclosed and patched, but not yet patched on all systems. A zero-day exploits a vulnerability the vendor doesn't know about. Once a patch exists, exploitation is no longer 'zero-day' even if many systems remain unpatched."
    },
    {
        id: 20, domain: "D2",
        q: "A worm is differentiated from a virus primarily by its ability to:",
        options: [
            "Encrypt files for ransom",
            "Self-propagate without requiring user action or a host file",
            "Hide itself from antivirus software",
            "Provide remote access to attackers"
        ],
        correct: 1,
        explanation: "Worms self-propagate across networks without needing user action or a host file. Viruses require a host (file, document, executable) and typically spread via user action. Ransomware encrypts; rootkits hide; RATs provide remote access — those are functions, not propagation methods."
    },
    {
        id: 21, domain: "D2",
        q: "Which is the BEST example of a supply-chain attack?",
        options: [
            "An attacker phishes credentials from an end user",
            "Malicious code is inserted into a widely-used open-source library that is then included in many downstream applications",
            "A disgruntled employee deletes files on their last day",
            "An attacker brute-forces an exposed RDP server"
        ],
        correct: 1,
        explanation: "Supply-chain attacks compromise trusted upstream components (libraries, vendors, hardware, build pipelines) to reach downstream targets. SolarWinds and event-stream are textbook examples. The other answers are direct attacks against the target itself."
    },
    {
        id: 22, domain: "D2",
        q: "A penetration tester sends crafted ARP responses to a switch, causing other hosts on the LAN to send traffic intended for the gateway through the tester's machine. What attack is this?",
        options: [
            "DNS spoofing",
            "ARP poisoning (on-path attack)",
            "MAC flooding",
            "VLAN hopping"
        ],
        correct: 1,
        explanation: "ARP poisoning forges ARP messages so other hosts associate the attacker's MAC with another host's IP (often the gateway). Traffic flows through the attacker, enabling on-path interception. Mitigations: dynamic ARP inspection (DAI), static ARP entries, port security."
    },
    {
        id: 23, domain: "D2",
        q: "A security team discovers that a custom-built application is logging users' passwords in clear text to a debug file. Which secure coding practice was MOST clearly violated?",
        options: [
            "Input validation",
            "Output encoding",
            "Sensitive data exposure prevention",
            "Cross-origin resource sharing"
        ],
        correct: 2,
        explanation: "Logging credentials in clear text is a textbook sensitive data exposure issue (OWASP Top 10). Logs are persistent, often forwarded to external systems, and frequently accessed by support staff — creating broad exposure of secrets that should never appear outside the authentication path."
    },
    {
        id: 24, domain: "D2",
        q: "Which technique BEST mitigates password spraying attacks against a public-facing portal?",
        options: [
            "Mandatory monthly password rotation",
            "Account lockout after too many failures, plus rate limiting and MFA",
            "CAPTCHA on the login page",
            "Disabling self-service password reset"
        ],
        correct: 1,
        explanation: "Password spraying tries one or two passwords against many accounts to evade per-account lockouts. The strongest mitigation combines account lockout, source-based rate limiting, anomaly detection (impossible travel, unusual hours), and MFA — which blocks success even when passwords are correct."
    },
    {
        id: 25, domain: "D2",
        q: "A logic bomb is BEST described as:",
        options: [
            "Malware that self-replicates over a network",
            "Malicious code that activates when specific conditions are met (date, event, user action)",
            "A vulnerability in physical hardware",
            "A scripted denial-of-service attack"
        ],
        correct: 1,
        explanation: "A logic bomb is dormant code that triggers on a specific condition — a date, the absence of a user account, a system event. Often planted by insiders before departure. Detection is hard because the malicious behavior only manifests at trigger time."
    },
    {
        id: 26, domain: "D2",
        q: "An attacker uses RF jamming near a corporate campus to disrupt wireless communications. Which security objective is MOST directly impacted?",
        options: [
            "Confidentiality",
            "Integrity",
            "Availability",
            "Non-repudiation"
        ],
        correct: 2,
        explanation: "Jamming targets availability — disrupting access to a service. Confidentiality is about disclosure, integrity is about modification, non-repudiation is about denial of action. Wireless jamming makes the system unusable but does not (by itself) read or alter data."
    },
    {
        id: 27, domain: "D2",
        q: "A user opens a Microsoft Word document that prompts to enable macros. After enabling, a connection is made to an attacker's server and additional malware is downloaded. The Word document's role is BEST classified as:",
        options: [
            "Worm",
            "Dropper / staged delivery",
            "Logic bomb",
            "Rootkit"
        ],
        correct: 1,
        explanation: "The macro acts as a dropper (or stager) — its job is to fetch and install the actual payload. The Word document is the initial vector; the macro is the dropper; the second-stage download is the real malware. Worms self-propagate; logic bombs are condition-triggered; rootkits hide presence."
    },
    {
        id: 28, domain: "D2",
        q: "A security team observes that an internal user account is making extremely large queries against the customer database late at night, with results being copied to an external cloud storage service. This pattern BEST indicates:",
        options: [
            "Routine database maintenance",
            "Insider data exfiltration",
            "DDoS attack",
            "Zero-day exploit"
        ],
        correct: 1,
        explanation: "Anomalous off-hours activity by a legitimate internal account, paired with bulk data movement to an external storage service, is a classic insider exfiltration pattern. Detection relies on UEBA (user and entity behavior analytics), DLP, and CASB controls."
    },
    {
        id: 29, domain: "D2",
        q: "Which mitigation is MOST effective against buffer overflow exploitation on modern operating systems?",
        options: [
            "Disabling antivirus to free up CPU",
            "ASLR (Address Space Layout Randomization) and DEP/NX",
            "Increasing default stack size in the kernel",
            "Blocking ICMP at the network perimeter"
        ],
        correct: 1,
        explanation: "ASLR randomizes memory addresses each execution, making it hard to reliably target injected code. DEP/NX marks data pages as non-executable, preventing shellcode from running. Together they make buffer overflow exploitation significantly harder. Modern compilers also add stack canaries."
    },
    {
        id: 30, domain: "D2",
        q: "A company learns that a popular industry forum has been compromised. Several employees who routinely visit the forum had their workstations infected with malware. This is an example of:",
        options: [
            "Whaling",
            "Watering hole attack",
            "Vishing",
            "Pharming"
        ],
        correct: 1,
        explanation: "A watering hole attack compromises a website that the target group is known to visit, infecting visitors with malware. Targets self-select by visiting the trusted site. Industry-specific forums and partner websites are common watering holes for targeted operations."
    },
    {
        id: 31, domain: "D2",
        q: "An organization wants to reduce the impact of compromised endpoints by limiting their ability to communicate freely with the internal network. Which control BEST achieves this?",
        options: [
            "Disabling the local firewall",
            "Microsegmentation with east-west traffic policies",
            "Increasing internet bandwidth",
            "Mandatory SSL on all internal connections"
        ],
        correct: 1,
        explanation: "Microsegmentation enforces granular traffic policies between workloads (east-west) so that a compromised host cannot freely communicate with peers. This limits lateral movement, the primary mechanism by which initial footholds become major breaches."
    },

    /* ============= DOMAIN 3: Security Architecture (16) ============= */
    {
        id: 32, domain: "D3",
        q: "An organization is migrating to AWS using EC2, RDS, and S3. Under the shared responsibility model, the organization is responsible for:",
        options: [
            "Patching the hypervisor",
            "Physical security of the AWS data centers",
            "Configuring security groups, IAM policies, and OS-level patching of EC2 instances",
            "Replacing failed disks in S3 storage clusters"
        ],
        correct: 2,
        explanation: "AWS handles 'security OF the cloud' (physical, hypervisor, host OS, hardware). The customer handles 'security IN the cloud' — guest OS, applications, configurations, network controls (security groups), IAM, and data. RDS and S3 shift more responsibility to AWS but customers still manage access policies and data."
    },
    {
        id: 33, domain: "D3",
        q: "A development team wants to deploy a web application that scales automatically and only pays per execution. The team also wants minimal infrastructure management. Which model BEST fits?",
        options: [
            "IaaS using VMs and load balancers",
            "PaaS with always-on dynos",
            "Serverless functions (FaaS)",
            "On-premises bare-metal hosting"
        ],
        correct: 2,
        explanation: "Serverless / Function-as-a-Service (Lambda, Azure Functions, Cloud Run) automatically scales per request and bills per execution time. The provider manages all infrastructure. IaaS and on-prem require capacity management. PaaS with always-on dynos pays for idle time."
    },
    {
        id: 34, domain: "D3",
        q: "A company places its public-facing web servers in a separate network segment with strictly limited inbound/outbound rules. This is an example of:",
        options: [
            "VLAN trunking",
            "Screened subnet (DMZ)",
            "Microsegmentation",
            "Bastion isolation"
        ],
        correct: 1,
        explanation: "A screened subnet (historically called a DMZ) is a network segment that exposes external-facing services while strictly limiting their access to the internal network. The current preferred term is 'screened subnet' — DMZ is being phased out of vendor documentation."
    },
    {
        id: 35, domain: "D3",
        q: "Which control BEST protects data at rest on a stolen laptop?",
        options: [
            "TLS 1.3 with mutual authentication",
            "Full-disk encryption (e.g., BitLocker, FileVault)",
            "Network-level VPN",
            "Application-layer DRM"
        ],
        correct: 1,
        explanation: "Full-disk encryption protects all data when the device is powered off — critical for stolen or lost devices. TLS protects data in transit, not at rest. VPN is also for transit. DRM controls access to specific content but does not protect the underlying disk if the device is powered off."
    },
    {
        id: 36, domain: "D3",
        q: "Which firewall type provides Layer 7 awareness, can decrypt and inspect TLS, and integrates with threat intelligence feeds?",
        options: [
            "Packet filtering firewall",
            "Stateful firewall",
            "Next-Generation Firewall (NGFW)",
            "Network Address Translation gateway"
        ],
        correct: 2,
        explanation: "NGFWs combine stateful inspection with application identification (Layer 7), TLS decryption, integrated IDS/IPS, and threat intelligence. Packet filters work only at L3/L4 statelessly. Stateful firewalls track connections but generally lack application awareness. NAT gateways perform translation, not inspection."
    },
    {
        id: 37, domain: "D3",
        q: "A network admin sees that the IPS is configured 'inline' rather than 'monitor mode'. What is the trade-off?",
        options: [
            "Inline mode reduces detection capability but improves uptime",
            "Inline mode can block attacks in real time but introduces a single point of failure if the device fails closed",
            "Inline mode requires SSL VPN and TACACS+ to operate",
            "Inline mode disables logging"
        ],
        correct: 1,
        explanation: "Inline (in-band) IPS sees and acts on traffic in real time, blocking malicious packets. Trade-off: device failure can disrupt traffic depending on fail-open/fail-closed behavior. Monitor mode (out-of-band) only alerts and cannot block, but never breaks traffic flow."
    },
    {
        id: 38, domain: "D3",
        q: "An organization needs encrypted, authenticated communication between two corporate sites over the public internet. Which is the MOST common and appropriate choice?",
        options: [
            "Site-to-site IPsec VPN tunnel",
            "Host-based TLS to every endpoint",
            "Plaintext MPLS",
            "Wireless Direct Connect"
        ],
        correct: 0,
        explanation: "A site-to-site IPsec VPN tunnel between the two perimeter gateways encrypts all inter-site traffic transparently. Endpoint-to-endpoint TLS is far more complex to manage at scale. Plaintext MPLS provides isolation but no encryption. WireGuard is also a valid modern alternative but not listed."
    },
    {
        id: 39, domain: "D3",
        q: "A security architect chooses a 'fail-closed' design for the network's authentication system. What does this mean if the authentication service becomes unavailable?",
        options: [
            "All traffic is allowed without authentication",
            "All access is denied until the service is restored",
            "Cached credentials remain valid indefinitely",
            "Users are routed to a guest VLAN"
        ],
        correct: 1,
        explanation: "Fail-closed (also called fail-secure) denies access on failure — prioritizing security. Fail-open allows access on failure — prioritizing availability. The choice depends on the threat model: a hospital ED might fail-open for life safety; a vault would fail-closed."
    },
    {
        id: 40, domain: "D3",
        q: "A company wants to ensure that even if the certificate authority is compromised, attackers cannot use a fraudulent certificate to impersonate the company's mobile API. Which technique BEST addresses this?",
        options: [
            "TLS 1.3 with forward secrecy",
            "Certificate pinning in the mobile application",
            "Wildcard certificates",
            "Self-signed certificates"
        ],
        correct: 1,
        explanation: "Certificate pinning hardcodes the expected certificate or public key in the application, so the app rejects any cert not matching — even if signed by a 'trusted' but compromised CA. Forward secrecy protects past sessions, not impersonation. Wildcard and self-signed certs do not solve this."
    },
    {
        id: 41, domain: "D3",
        q: "An organization classifies data and finds that its customer order history is most accurately labeled as:",
        options: [
            "Public",
            "Sensitive (Internal use only)",
            "Confidential — including PII",
            "Restricted — requires special clearance"
        ],
        correct: 2,
        explanation: "Customer order history contains personally identifiable information (PII) and contractually obligated commercial data, placing it firmly in the Confidential tier. Public data is publicly releasable; Sensitive/Internal is not for outside disclosure but lacks PII; Restricted is for highly classified data."
    },
    {
        id: 42, domain: "D3",
        q: "A business has an RTO of 4 hours and an RPO of 15 minutes for its customer database. Which DR strategy BEST satisfies both?",
        options: [
            "Cold site with weekly tape backups shipped offsite",
            "Warm site with nightly backups",
            "Hot site with synchronous or near-synchronous replication and frequent transaction-log shipping",
            "No DR — rely on internal recovery"
        ],
        correct: 2,
        explanation: "RPO of 15 minutes requires very frequent replication (sync/near-sync). RTO of 4 hours requires standby infrastructure ready to take over quickly — a hot site. Cold and warm sites cannot meet a 4-hour RTO. Lacking any DR is unacceptable for the stated objectives."
    },
    {
        id: 43, domain: "D3",
        q: "Which characteristic BEST distinguishes containers from virtual machines?",
        options: [
            "Containers are slower to start than VMs",
            "Containers share the host kernel; VMs include their own guest kernel",
            "Containers cannot run on Linux",
            "Containers always require a hypervisor"
        ],
        correct: 1,
        explanation: "Containers use OS-level virtualization, sharing the host kernel — making them lightweight and fast. VMs use hardware-level virtualization with their own guest OS and kernel — heavier but more isolated. The shared kernel is a security concern: a kernel exploit can affect all containers."
    },
    {
        id: 44, domain: "D3",
        q: "An organization moves authentication, secure web gateway, ZTNA, and CASB into a single cloud-delivered service combined with SD-WAN. Which architecture BEST describes this?",
        options: [
            "MPLS",
            "SASE (Secure Access Service Edge)",
            "VRF (Virtual Routing and Forwarding)",
            "GRE tunneling"
        ],
        correct: 1,
        explanation: "SASE converges SD-WAN with cloud-delivered security services (FWaaS, SWG, CASB, ZTNA) at the network edge. The model fits a cloud-first, remote-workforce environment better than legacy hub-and-spoke MPLS-with-perimeter-firewall designs."
    },
    {
        id: 45, domain: "D3",
        q: "Why does TLS 1.3 reduce handshake latency compared to TLS 1.2?",
        options: [
            "It requires no certificate validation",
            "It uses TCP fast open by default",
            "It completes the handshake in 1 round-trip (1-RTT) and supports 0-RTT resumption",
            "It eliminates encryption to speed things up"
        ],
        correct: 2,
        explanation: "TLS 1.3 simplifies the handshake by combining steps and removing legacy negotiation, achieving full handshake in 1 RTT (vs 2 in TLS 1.2). Resumption can be 0-RTT, sending application data with the first message — though 0-RTT has replay caveats."
    },
    {
        id: 46, domain: "D3",
        q: "Which scenario is the BEST candidate for using a jump server (bastion host)?",
        options: [
            "Routing public web traffic to internal databases",
            "Providing controlled administrative SSH access to a sensitive internal subnet",
            "Encrypting email at rest",
            "Bypassing VPN authentication for executives"
        ],
        correct: 1,
        explanation: "Jump servers provide a single, hardened, monitored entry point into a sensitive subnet. All admin sessions flow through it, enabling auditing, MFA enforcement, and restricted egress. They are not for general traffic, encryption, or bypassing authentication."
    },
    {
        id: 47, domain: "D3",
        q: "An admin notices that snapshots of a production VM are being relied on as the company's only backup. What is the PRIMARY weakness of this approach?",
        options: [
            "Snapshots take too much storage",
            "Snapshots typically reside on the same storage as the source — a failure or ransomware on that storage destroys both",
            "Snapshots are not encrypted",
            "Snapshots cannot be restored quickly"
        ],
        correct: 1,
        explanation: "Snapshots are point-in-time references, often stored alongside the source. If the underlying storage fails or is encrypted by ransomware, both production data and snapshots are lost. True backups must be off-system, ideally following the 3-2-1 rule (3 copies, 2 media, 1 offsite/immutable)."
    },

    /* ============= DOMAIN 4: Security Operations (25) ============= */
    {
        id: 48, domain: "D4",
        q: "Which combination represents TRUE multi-factor authentication?",
        options: [
            "A password and a security question",
            "A fingerprint and a retina scan",
            "A password and a hardware token",
            "Two different passwords"
        ],
        correct: 2,
        explanation: "True MFA combines factors of DIFFERENT TYPES: something you know (password), have (token), are (biometric), do (gesture), or where (location). A password + security question is two 'know' factors — not real MFA. Two biometrics (finger + retina) is also one factor type used twice."
    },
    {
        id: 49, domain: "D4",
        q: "A security engineer needs to authenticate network device administrators with full session encryption and granular command authorization. Which protocol is BEST?",
        options: [
            "RADIUS",
            "TACACS+",
            "Kerberos",
            "LDAP"
        ],
        correct: 1,
        explanation: "TACACS+ encrypts the entire packet payload and supports granular per-command authorization — making it the standard for network device administration. RADIUS encrypts only the password field and primarily handles user authentication. Kerberos is for ticket-based SSO. LDAP is a directory protocol."
    },
    {
        id: 50, domain: "D4",
        q: "An organization implements a system where temporary administrative privileges are issued only when needed and automatically revoked after a defined window. This is BEST described as:",
        options: [
            "Role-Based Access Control",
            "Just-In-Time (JIT) privileged access",
            "Federated identity",
            "Discretionary Access Control"
        ],
        correct: 1,
        explanation: "Just-In-Time access grants elevated privileges only when needed and removes them automatically afterward — drastically reducing standing privilege exposure. RBAC defines static role permissions. Federation handles cross-domain identity. DAC is owner-driven access management."
    },
    {
        id: 51, domain: "D4",
        q: "Which authentication factor is 'something you ARE'?",
        options: [
            "A smart card",
            "A 12-character password",
            "A fingerprint",
            "Geolocation"
        ],
        correct: 2,
        explanation: "'Something you are' = inherent/biometric factor (fingerprint, retina, face, voice). 'Have' = smart card or token. 'Know' = password or PIN. 'Where' = geolocation. 'Do' = behavioral signature (keystroke dynamics, gestures)."
    },
    {
        id: 52, domain: "D4",
        q: "An EDR platform detects suspicious behavior on an endpoint and automatically isolates it from the network while preserving forensic data. This response capability BEST exemplifies which IR phase?",
        options: [
            "Preparation",
            "Identification",
            "Containment",
            "Recovery"
        ],
        correct: 2,
        explanation: "Isolating the endpoint to prevent further damage and lateral movement is containment. Identification confirmed the incident; preparation predates the event; recovery comes after eradication. Modern EDR/XDR tools blur the lines by combining identification with automated containment."
    },
    {
        id: 53, domain: "D4",
        q: "Which document records every transfer of digital evidence — who took it, when, and what was done with it?",
        options: [
            "Acceptable Use Policy",
            "Chain of Custody",
            "Risk Register",
            "Memorandum of Understanding"
        ],
        correct: 1,
        explanation: "Chain of custody is the chronological log of evidence handling — required to preserve admissibility in legal proceedings. Any gap or unaccountability can render evidence unusable. AUPs govern user behavior; risk registers track risks; MOUs document inter-party agreements."
    },
    {
        id: 54, domain: "D4",
        q: "Which email authentication mechanism uses a digital signature in the email header that recipients verify against a public key in DNS?",
        options: [
            "SPF",
            "DKIM",
            "DMARC",
            "S/MIME"
        ],
        correct: 1,
        explanation: "DKIM (DomainKeys Identified Mail) signs the message with the sender's private key and publishes the public key in DNS. SPF lists authorized sending IPs. DMARC ties SPF/DKIM results to a policy and reporting. S/MIME signs/encrypts message content end-to-end, but is per-user, not domain-wide."
    },
    {
        id: 55, domain: "D4",
        q: "A company configures its DMARC policy to 'p=reject'. What does this instruct receiving mail servers to do with messages failing SPF/DKIM alignment?",
        options: [
            "Quarantine them in the spam folder",
            "Deliver them with a warning banner",
            "Reject (bounce) them outright",
            "Rate-limit them"
        ],
        correct: 2,
        explanation: "DMARC policies: p=none (monitor only), p=quarantine (move to spam), p=reject (refuse delivery). Reject is the strongest stance — used after monitoring confirms no legitimate mail is being broken."
    },
    {
        id: 56, domain: "D4",
        q: "Which platform aggregates security logs from across the enterprise and correlates events to surface threats?",
        options: [
            "SIEM",
            "WAF",
            "PAM",
            "DLP"
        ],
        correct: 0,
        explanation: "SIEM (Security Information and Event Management) ingests logs from endpoints, network devices, applications, and identity systems, then correlates events to detect threats. WAF protects web apps; PAM controls privileged access; DLP prevents data exfiltration."
    },
    {
        id: 57, domain: "D4",
        q: "Which of the following BEST describes a SOAR platform?",
        options: [
            "A passive log collector",
            "An identity provider for federated SSO",
            "A platform that orchestrates and automates incident response playbooks across security tools",
            "A patch management server"
        ],
        correct: 2,
        explanation: "SOAR (Security Orchestration, Automation, and Response) automates IR playbooks — enriching alerts, executing responses across integrated tools, and reducing analyst toil. SIEM detects; SOAR responds. Identity providers, log collectors, and patch managers serve different functions."
    },
    {
        id: 58, domain: "D4",
        q: "A vulnerability scan reports CVE-2024-XXXX with a CVSS score of 8.7. How is this severity classified?",
        options: [
            "Low",
            "Medium",
            "High",
            "Critical"
        ],
        correct: 2,
        explanation: "CVSS v3.x severity bands: None (0.0), Low (0.1–3.9), Medium (4.0–6.9), High (7.0–8.9), Critical (9.0–10.0). 8.7 falls in the High range. Treat High as priority for prompt remediation; Critical as emergency."
    },
    {
        id: 59, domain: "D4",
        q: "Which testing method analyzes source code WITHOUT executing the program?",
        options: [
            "DAST (Dynamic Application Security Testing)",
            "SAST (Static Application Security Testing)",
            "IAST (Interactive Application Security Testing)",
            "Penetration testing"
        ],
        correct: 1,
        explanation: "SAST examines source/binary code without executing it, finding flaws like SQL injection patterns, hardcoded credentials, and insecure functions. DAST tests running applications. IAST instruments the running app for hybrid analysis. Pen testing is broader, end-to-end exploitation."
    },
    {
        id: 60, domain: "D4",
        q: "An organization wants to detect unauthorized changes to critical system files like /etc/passwd or kernel modules. Which control BEST fits?",
        options: [
            "Antivirus signatures only",
            "File Integrity Monitoring (FIM)",
            "DDoS protection",
            "Access logging via syslog"
        ],
        correct: 1,
        explanation: "FIM (File Integrity Monitoring) hashes critical files and alerts on any change. Tools: Tripwire, OSSEC, Wazuh, native auditd. AV detects known malware; DDoS protection is unrelated; syslog records access but doesn't easily detect content changes."
    },
    {
        id: 61, domain: "D4",
        q: "A user can read but not modify a shared finance spreadsheet. The operating system enforces this through ACLs the file owner configured. Which access control model is in use?",
        options: [
            "MAC (Mandatory Access Control)",
            "DAC (Discretionary Access Control)",
            "RBAC (Role-Based Access Control)",
            "ABAC (Attribute-Based Access Control)"
        ],
        correct: 1,
        explanation: "DAC is owner-driven: the resource owner decides who has what access. NTFS and POSIX permissions are DAC. MAC is system-enforced via labels; RBAC ties access to roles; ABAC uses attributes/policies. The phrase 'the file owner configured' is the giveaway for DAC."
    },
    {
        id: 62, domain: "D4",
        q: "An organization wants to ensure remote workers' laptops only allow the corporate VPN connection — no split tunneling. Which configuration achieves this?",
        options: [
            "Full-tunnel VPN policy with all traffic forced through the VPN",
            "Always-on TLS",
            "Disable IPv6",
            "Use a proxy server"
        ],
        correct: 0,
        explanation: "Full-tunnel VPN routes ALL traffic through the corporate VPN — no direct internet access from the remote endpoint. This applies corporate inspection and policy to all activity. Split-tunnel VPN sends only corporate traffic via VPN and lets internet traffic go direct."
    },
    {
        id: 63, domain: "D4",
        q: "A SOC analyst is performing threat hunting using MITRE ATT&CK. Which is the BEST description of this activity?",
        options: [
            "Reactively responding to SIEM alerts as they fire",
            "Proactively searching for threats that may have evaded existing controls, using known TTPs as hypotheses",
            "Blocking all suspicious IPs at the firewall",
            "Running monthly vulnerability scans"
        ],
        correct: 1,
        explanation: "Threat hunting is proactive — assuming compromise and searching for it before alerts fire. MITRE ATT&CK provides the TTP catalog. Hunters form hypotheses ('if a threat actor is in our environment, what would I see?') and test against telemetry. Reactive alert handling is monitoring, not hunting."
    },
    {
        id: 64, domain: "D4",
        q: "A company uses TOTP for MFA. The TOTP secret is shared between the authenticator app and the server. The OTP changes every 30 seconds. What property does TOTP rely on?",
        options: [
            "Asymmetric encryption",
            "A shared secret combined with the current time",
            "Public key infrastructure",
            "Biometric uniqueness"
        ],
        correct: 1,
        explanation: "TOTP (RFC 6238) generates codes from HMAC(shared_secret, current_30s_window). Because both sides know the secret and have synced time, codes match without communication during use. Codes change every 30s, limiting the replay window."
    },
    {
        id: 65, domain: "D4",
        q: "An OAuth 2.0 'access token' typically grants:",
        options: [
            "Permanent administrative access to the resource server",
            "Time-limited authorization to access specific resources on behalf of the user",
            "Direct access to the user's password",
            "Database root credentials"
        ],
        correct: 1,
        explanation: "OAuth 2.0 access tokens are time-limited bearer credentials authorizing specific scopes on the resource server, on behalf of the user — without exposing the user's password. Short lifetimes (minutes to hours) are paired with refresh tokens for renewal. Admin access is a separate scope decision."
    },
    {
        id: 66, domain: "D4",
        q: "What is the PRIMARY advantage of SAML for enterprise applications?",
        options: [
            "It is the only protocol that uses TLS",
            "It enables federated single sign-on across organizational boundaries using an XML-based assertion",
            "It encrypts all database queries",
            "It replaces the need for any password"
        ],
        correct: 1,
        explanation: "SAML allows an identity provider in one domain to assert authentication and attributes about a user to a service provider in another domain — enabling federated SSO. The assertion is XML-based and digitally signed. SAML doesn't replace passwords; it just doesn't require sharing them with each app."
    },
    {
        id: 67, domain: "D4",
        q: "Which is the MOST important first step in incident response when a user reports suspicious behavior?",
        options: [
            "Reformat the system",
            "Contain and preserve evidence before further action",
            "Notify shareholders publicly",
            "Update antivirus signatures globally"
        ],
        correct: 1,
        explanation: "Containment and evidence preservation come first — premature reformatting destroys forensic data and root-cause information. Public notification follows established communication plans, not initial response. AV updates are useful but secondary to immediate containment."
    },
    {
        id: 68, domain: "D4",
        q: "A web filtering proxy categorizes a domain as 'newly registered' and blocks access by default. The PRIMARY rationale is:",
        options: [
            "Newly registered domains are slower",
            "Newly registered domains are disproportionately associated with phishing and malware infrastructure",
            "Newly registered domains have lower SEO ranking",
            "ICANN requires it"
        ],
        correct: 1,
        explanation: "A high percentage of newly registered domains (NRDs) are used in phishing, malware C2, and fraud — attackers register new domains to evade reputation filters. Blocking or sandboxing access to NRDs for an initial cooling-off period is a strong defense."
    },
    {
        id: 69, domain: "D4",
        q: "A SOC analyst notices anomalous logins from a user account: California 09:00, Tokyo 09:30, London 10:00 — same day. The MOST likely cause is:",
        options: [
            "VPN tunneling",
            "Compromised credentials being abused from multiple regions, or a 'impossible travel' anomaly",
            "Fast travel by the user",
            "DNS misconfiguration"
        ],
        correct: 1,
        explanation: "Impossible travel — geographically distant logins within an impossibly short window — strongly suggests credential compromise or shared/leaked credentials. Modern UEBA tools surface this automatically. VPN/proxy use can produce false positives, but combined with other signals (different OS, IPs) the verdict is usually compromise."
    },
    {
        id: 70, domain: "D4",
        q: "Which of the following BEST describes the purpose of a privileged access workstation (PAW)?",
        options: [
            "A workstation reserved for remote employees",
            "A hardened, dedicated workstation used solely for performing administrative tasks, isolated from email/web/general workloads",
            "A laptop with extra RAM",
            "A jump server hosted in the cloud"
        ],
        correct: 1,
        explanation: "PAWs are physically/logically separated from general productivity workstations. Admins use them ONLY for privileged tasks (no email, no web). This dramatically reduces the chance of credentials being compromised by a phishing email opened on the same machine."
    },
    {
        id: 71, domain: "D4",
        q: "Which strategy is MOST effective at reducing the impact of a single account compromise on critical systems?",
        options: [
            "Allow users to reuse passwords across systems",
            "Enforce least privilege, MFA, and just-in-time elevation for sensitive actions",
            "Disable account lockout to avoid lockouts",
            "Use the same admin account for all servers"
        ],
        correct: 1,
        explanation: "Least privilege limits what any single account can access; MFA blocks most credential abuse; JIT elevation removes standing privilege. Together, these dramatically reduce blast radius. The other options actively increase risk."
    },
    {
        id: 72, domain: "D4",
        q: "A company implements full session recording on all privileged SSH connections through its bastion host. The PRIMARY benefit is:",
        options: [
            "Reduced bandwidth usage",
            "Forensic record for accountability and post-incident review",
            "Faster command execution",
            "Eliminating the need for MFA"
        ],
        correct: 1,
        explanation: "Session recording creates an evidentiary trail of every command executed during a privileged session — vital for incident investigation, audit, and accountability. It does not replace MFA, reduce bandwidth, or speed execution."
    },

    /* ============= DOMAIN 5: Program Management & Oversight (18) ============= */
    {
        id: 73, domain: "D5",
        q: "An asset is valued at $200,000. A particular threat is expected to cause 25% damage if it occurs. What is the SLE?",
        options: [
            "$5,000",
            "$25,000",
            "$50,000",
            "$200,000"
        ],
        correct: 2,
        explanation: "SLE = Asset Value × Exposure Factor = $200,000 × 0.25 = $50,000. SLE represents the loss from a SINGLE occurrence. Multiplied by ARO (Annual Rate of Occurrence) yields ALE."
    },
    {
        id: 74, domain: "D5",
        q: "Using the previous question's data, if the threat is expected to occur once every 5 years, what is the ALE?",
        options: [
            "$2,500",
            "$10,000",
            "$25,000",
            "$50,000"
        ],
        correct: 1,
        explanation: "ARO = 1/5 = 0.2. ALE = SLE × ARO = $50,000 × 0.2 = $10,000. This figure justifies how much the organization should be willing to spend annually on controls. A control costing more than ALE provides poor ROI unless other factors apply."
    },
    {
        id: 75, domain: "D5",
        q: "A risk treatment that involves purchasing cyber insurance is BEST classified as:",
        options: [
            "Risk avoidance",
            "Risk mitigation",
            "Risk transfer",
            "Risk acceptance"
        ],
        correct: 2,
        explanation: "Insurance shifts (transfers) financial risk to a third party. Avoidance eliminates the activity. Mitigation reduces likelihood/impact through controls. Acceptance acknowledges and lives with the risk. Note that insurance does not transfer regulatory or reputational consequences."
    },
    {
        id: 76, domain: "D5",
        q: "Under GDPR, the entity that determines the purposes and means of processing personal data is the:",
        options: [
            "Data Subject",
            "Data Processor",
            "Data Controller",
            "Data Custodian"
        ],
        correct: 2,
        explanation: "GDPR defines the Data Controller as the entity making decisions about WHY and HOW personal data is processed — and they bear primary accountability. Processors act on the controller's behalf under contract. Subjects are the people the data is about. Custodians (a US/security term) handle operational duties."
    },
    {
        id: 77, domain: "D5",
        q: "An organization handling cardholder data must comply with which contractually-mandated standard?",
        options: [
            "HIPAA",
            "PCI-DSS",
            "SOX",
            "FERPA"
        ],
        correct: 1,
        explanation: "PCI-DSS is required of any organization that stores, processes, or transmits cardholder data. It is contractual (set by card brands), not government law. HIPAA = US health data; SOX = US public company financial controls; FERPA = US student education records."
    },
    {
        id: 78, domain: "D5",
        q: "Which agreement is non-binding and typically used to outline mutual intentions between two parties?",
        options: [
            "SLA",
            "MOU",
            "MSA",
            "NDA"
        ],
        correct: 1,
        explanation: "MOU (Memorandum of Understanding) documents intent to cooperate but is generally non-binding. SLAs define service performance metrics and penalties. MSAs are master commercial contracts. NDAs are binding confidentiality contracts."
    },
    {
        id: 79, domain: "D5",
        q: "A penetration tester is given full access to source code, network diagrams, and credentials for the engagement. This is BEST described as:",
        options: [
            "Black-box (unknown environment) testing",
            "Gray-box (partially known environment) testing",
            "White-box (known environment) testing",
            "Phishing simulation"
        ],
        correct: 2,
        explanation: "White-box (known environment) testing provides the tester with full information — source, architecture, credentials. Maximizes coverage; mimics insider perspective. Black-box has no info; gray-box has partial info (often a user-level account)."
    },
    {
        id: 80, domain: "D5",
        q: "Which framework's five functions are: Identify, Protect, Detect, Respond, Recover?",
        options: [
            "ISO 27001",
            "NIST Cybersecurity Framework (CSF)",
            "PCI-DSS",
            "COBIT"
        ],
        correct: 1,
        explanation: "The NIST CSF organizes cybersecurity activities into five core functions: Identify, Protect, Detect, Respond, Recover (with Govern added in CSF 2.0). ISO 27001 specifies ISMS requirements differently. PCI-DSS is prescriptive controls. COBIT focuses on IT governance."
    },
    {
        id: 81, domain: "D5",
        q: "A company conducts a tabletop exercise simulating a ransomware attack. The PRIMARY goal is to:",
        options: [
            "Catch the actual attackers",
            "Validate the IR plan, identify gaps, and train participants without operational disruption",
            "Replace live exercises permanently",
            "Earn certification credit"
        ],
        correct: 1,
        explanation: "Tabletop exercises are discussion-based simulations. Participants walk through their roles for a hypothetical scenario, exposing planning gaps and misunderstandings BEFORE an actual incident. They complement (not replace) live exercises and red-team engagements."
    },
    {
        id: 82, domain: "D5",
        q: "An organization adds a 'right-to-audit' clause to a vendor contract. The MOST direct purpose is to:",
        options: [
            "Enable invoicing flexibility",
            "Allow the organization to verify the vendor's security controls and compliance posture",
            "Negotiate price increases",
            "Replace the vendor's security team"
        ],
        correct: 1,
        explanation: "Right-to-audit lets the organization (or third party on their behalf) inspect the vendor's controls, often via questionnaire, on-site review, or SOC 2 attestation. Critical for vendor risk management — without it, the organization must rely entirely on the vendor's self-attestation."
    },
    {
        id: 83, domain: "D5",
        q: "A risk register entry shows: 'Ransomware against finance VMs, likelihood Medium, impact High, owner CFO, treatment Mitigate via offline backups + EDR + segmentation.' Which item is the residual risk MOST sensitive to?",
        options: [
            "The number of CFO direct reports",
            "How effectively the chosen controls are implemented and maintained",
            "The CFO's title",
            "The age of the risk register"
        ],
        correct: 1,
        explanation: "Residual risk is what remains after controls are applied. Its level depends entirely on whether the chosen controls are correctly implemented and continuously effective. Stale or misconfigured backups, partial segmentation, or unpatched EDR all leave residual risk unchanged."
    },
    {
        id: 84, domain: "D5",
        q: "Under GDPR, the maximum window to notify the supervisory authority of a personal data breach is:",
        options: [
            "24 hours",
            "72 hours",
            "30 days",
            "Whenever convenient"
        ],
        correct: 1,
        explanation: "GDPR Article 33 requires notification 'without undue delay and, where feasible, not later than 72 hours after having become aware'. Failure to comply can attract penalties up to 2% of global revenue (separate from breach-specific penalties up to 4%)."
    },
    {
        id: 85, domain: "D5",
        q: "Which is the BEST example of due care?",
        options: [
            "Researching multiple cloud providers before selecting one",
            "Implementing reasonable controls (encryption, MFA, IR plan) to protect customer data",
            "Reading vendor contract terms",
            "Conducting market analysis"
        ],
        correct: 1,
        explanation: "Due care is the act of doing what a reasonable person would do — implementing protections. Due diligence is the act of investigating before action (research, vendor review). Distinguish: diligence = looking; care = doing."
    },
    {
        id: 86, domain: "D5",
        q: "Which is a Key Risk Indicator (KRI)?",
        options: [
            "A measurement of overall employee satisfaction",
            "Percentage of endpoints out of compliance with the patching SLA",
            "Annual marketing budget",
            "Number of registered domains"
        ],
        correct: 1,
        explanation: "KRIs are metrics that signal increasing risk exposure. % of unpatched endpoints, failed login rate, mean time to detect, and similar metrics are direct risk indicators. They feed dashboards and trigger reviews when thresholds are crossed."
    },
    {
        id: 87, domain: "D5",
        q: "A fictitious scenario: an organization decides not to enter a foreign market because the regulatory and data sovereignty risk is too high. This decision is BEST described as risk:",
        options: [
            "Mitigation",
            "Transfer",
            "Avoidance",
            "Acceptance"
        ],
        correct: 2,
        explanation: "Refusing to engage in the activity that creates the risk is risk avoidance — the most absolute treatment. Mitigation would mean entering with controls; transfer would mean entering with insurance/contracts; acceptance would mean entering knowing the risk."
    },
    {
        id: 88, domain: "D5",
        q: "A new privacy regulation grants individuals the right to demand deletion of their personal data, subject to certain exceptions. This right is commonly called:",
        options: [
            "Data Portability",
            "Right of Access",
            "Right to Be Forgotten / Right to Erasure",
            "Data Sovereignty"
        ],
        correct: 2,
        explanation: "The Right to Erasure (also known as the Right to Be Forgotten) is a key GDPR right. It is not absolute — exceptions apply for legal obligations, public interest, and legitimate retention. Portability lets users export data; access is the right to see it."
    },
    {
        id: 89, domain: "D5",
        q: "A vendor security questionnaire and SOC 2 Type II report are both forms of:",
        options: [
            "Penetration testing",
            "Vendor / third-party risk assessment",
            "Vulnerability scanning",
            "User access review"
        ],
        correct: 1,
        explanation: "Both are inputs to vendor / third-party risk assessment. Questionnaires are self-attested; SOC 2 Type II is independently audited over a period of time and offers stronger assurance. Mature programs combine both with right-to-audit clauses."
    },
    {
        id: 90, domain: "D5",
        q: "Which of these is the BEST description of security awareness training's ROLE in a security program?",
        options: [
            "It replaces technical controls",
            "It is a one-time event to satisfy compliance",
            "It builds the human layer of defense — recognition, reporting, and resistance to social engineering — to complement technical controls",
            "It is required only for IT staff"
        ],
        correct: 2,
        explanation: "Awareness training builds the human layer of defense. It does not replace technical controls — but technical controls cannot fully cover phishing and social engineering. Effective programs are continuous (not one-time), measured (phishing simulations), and apply to ALL staff including executives."
    }

];

if (typeof module !== 'undefined' && module.exports) module.exports = PRACTICE_QUESTIONS;

export default PRACTICE_QUESTIONS;
